export default __webpack_public_path__ + "static/media/install-app-1.e2928c2d.jpg";